import React from "react";

const RichText = ({ html, className }) => {
  return (
    <span
      className={`rte ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichText;
